var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DeliveredCompanyProfile',{attrs:{"lgSize":12,"lgOffset":0,"locParam":1,"idCity":0,"details":0,"title":_vm.company,"dFrom":_vm.date_from,"dTo":_vm.date_to}}),_c('DeliveredCompanyTable',{attrs:{"dFrom":_vm.date_from,"dTo":_vm.date_to,"title":_vm.company}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }